/* @flow */
import { Component } from 'react';
import PropTypes from 'prop-types';

class Base extends Component {}

export default Base;
